module.exports = __webpack_public_path__ + "img/vc.01f67852.png";